<template>
  <div class="main-wrapper" >

    <div class="main-scroll">
      <nav-com :flag="flag"></nav-com>
      <person-com></person-com>
      <foot-com class="foots"></foot-com>
    </div>
    <bottom-backtop></bottom-backtop>

  </div>
</template>

<script>
import NavCom from '../common/navs';
import FootCom from '../common/foots';
import PersonCom from './personInfo';
import BottomBacktop from '../common/BottomBacktop';


export default {
  name: 'personInfo',
  components: {
    NavCom,
    FootCom,
    PersonCom,
    BottomBacktop
  },
  data() {
    return {
      flag: false,
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
